import React from 'react';
import ReportsHub from '@pages/Common/ReportsHub/ReportsHub';
import ReportsAnalytics from './ReportAnalytics';

const AdminReportsHub: React.FC = () => <ReportsHub ReportsComponent={ReportsAnalytics} />;

export default AdminReportsHub;
